import { ServiceFetch } from '../service-fetch'

export default class MaintainModel extends ServiceFetch {
    getMaintain = (data) => this.authFetch({
        url: 'maintain/getMaintain',
        method: 'POST',
        body: JSON.stringify(data),
    })
}